'use strict';

angular.module('shiftTraderApp')
    .directive('saCreditCard', ['$timeout', function ($timeout) {
      return {
        templateUrl: 'views/directives/saCreditCard.html',
        restrict: 'A',
        scope: {
          me: '=',
          org: '=',
          cardData: '='
        },
        link: function(scope, elem) {
          scope.state = {
            creditCardFormErrors: [],
            isShowingAddCard: !(!!scope.cardData && !!scope.cardData.id)
          };

          scope.handleStripe = function(status, response) {
            console.log(status);
            console.log(response);
            scope.state.creditCardFormErrors = [];
            scope.state.cardAdditionSucceeded = false;

            if (status === 400) {
              _.each([['cardNumber', 'Card Number'], ['cardExpire', 'Expiration Date'], ['cardCVC', 'CVC Code'], ['cardName', 'Name on Card']], function(formFieldName) {
                if (scope.creditForm[formFieldName[0]].$invalid) {
                  scope.state.creditCardFormErrors.push({
                    text: 'Invalid ' + formFieldName[1] + '. Please double check.'
                  });

                  return false;
                }
              });

              // look through the fields and find which are invalid
            } else {
              if (response.error) {
                console.log('Stripe had an error');
                scope.state.creditCardFormErrors.push({
                  text: response.error.message
                });
              } else {
                console.log('success!!');
                console.log(response);
                scope.state.cardAdditionSucceeded = true;
                scope.cardData = response;
                setupBackSideCard();
                scope.state.isShowingAddCard = false;
              }
            }
          };

          var setupBackSideCard = function() {
            //$(elem).find('.flip_card_face.back_side form[name="fakeForm"]').card({

            console.log(scope.cardData);
            $('.flip_card_face.back_side .card-wrapper').empty();

            var backCard = new Card({
              form: '.flip_card_face.back_side form[name="fakeForm"]',
              // a selector or jQuery object for the container
              // where you want the card to appear
              container: '.flip_card_face.back_side .card-wrapper', // *required*
              numberInput: 'input#fake1', // optional — default input[name="number"]
              expiryInput: 'input#fake1', // optional — default input[name="expiry"]
              cvcInput: 'input#fake1', // optional — default input[name="cvc"]
              nameInput: 'input#fake1', // optional - defaults input[name="name"]

              width: 300, // optional — default 350px
              formatting: true, // optional - default true

              // Strings for translation - optional
              messages: {
                validDate: 'valid\ndate', // optional - default 'valid\nthru'
                monthYear: 'mm/yyyy' // optional - default 'month/year'
              },

              // Default values for rendered fields - options
              placeholders: {
                number: '•••• •••• •••• ' + scope.cardData.card.last4,
                name: scope.cardData.card.name,
                expiry: scope.cardData.card.exp_month + '/' + scope.cardData.card.exp_year,
                cvc: '•••'
              }
            });

            if (_.contains(['visa', 'discover', 'mastercard', 'amex'], scope.cardData.card.brand.toLowerCase())) {
              $(elem).find('.flip_card_face.back_side .card-wrapper .jp-card')
                  .addClass('jp-card-' + scope.cardData.card.brand.toLowerCase());

              $(elem).find('.flip_card_face.back_side .card-wrapper .jp-card').addClass('jp-card-identified');

            }
          };

          var setupFrontSideCard = function() {
            //$(elem).find('.flip_card_face.front_side form[name="creditForm"]').card({

            $('.flip_card_face.front_side .card-wrapper').empty();

            var frontCard = new Card({
              form: '.flip_card_face.front_side form[name="creditForm"]',
              // a selector or jQuery object for the container
              // where you want the card to appear
              container: '.flip_card_face.front_side .card-wrapper', // *required*
              numberInput: 'input#cardNumber', // optional — default input[name="number"]
              expiryInput: 'input#cardExpire', // optional — default input[name="expiry"]
              cvcInput: 'input#cardCVC', // optional — default input[name="cvc"]
              nameInput: 'input#cardName', // optional - defaults input[name="name"]

              width: 300, // optional — default 350px
              formatting: true, // optional - default true

              // Strings for translation - optional
              messages: {
                validDate: 'valid\ndate', // optional - default 'valid\nthru'
                monthYear: 'mm/yyyy' // optional - default 'month/year'
              },

              // Default values for rendered fields - options
              placeholders: {
                number: '•••• •••• •••• ••••',
                name: 'Full Name',
                expiry: '••/••••',
                cvc: '•••'
              }
            });

          };

          scope.addACard = function() {
            scope.number = '';
            scope.expiry = '';
            scope.cvc = '';
            scope.name = '';
            scope.addressZip = '';
            scope.state.isShowingAddCard = true;
            $timeout(function() {
              setupFrontSideCard();
            }, 100);

          };

          if (!scope.state.isShowingAddCard) {
            $timeout(setupBackSideCard, 100);
          } else {
            $timeout(setupFrontSideCard, 100);
          }

        }
      };
    }]);
